import React from 'react'

import Button from '../../../Button/Button'
import ButtonVariantEnum from '../../../../enums/ButtonVariant'
import ArrowRightIcon from '../../../../images/icons/arrow-right.svg'
import { NavList } from '../NavList/NavList'
import { useDrawerSubItem } from '../../Drawer.hook'
import { StyledNavLink, StyledNavListItem } from './NavListItem.styled'


const NavListItem = ({item, onClickNext, companyNavigation }) => {

  const { color, currentSlug, hasSubitems, items, slideRef} = useDrawerSubItem(companyNavigation, item)

  return (
    <StyledNavListItem isColored={color}>
      <StyledNavLink href={currentSlug}>{item.name}</StyledNavLink>
      {
        hasSubitems && (
          <>
            <Button
              variant={ButtonVariantEnum.tertiary}
              title={`Go to sublist of ${item.name}`}
              iconOnly
              onClick={() => onClickNext(slideRef)}
            >
              <ArrowRightIcon />
            </Button>
            <NavList items={items} title={item.name} onClickNext={onClickNext} isSubNav ref={slideRef}/>
          </>
        )}
    </StyledNavListItem>
  )
}

export default NavListItem